import { atom, selector, selectorFamily } from "recoil";
import {
  categoryType,
  getCategory,
  getCategoryDetail,
  getCategoryRequestList,
  getProject,
  getProjectList,
  projectType,
} from "lib/store/project";

import { sentimentCalc } from "lib/atsent";

export const currentProject = atom({
  key: "PROJECT/id",
  default: parseInt(window.location.pathname.split("/")[1]),
});

export const projectListUpdate = atom({
  key: "PROJECT/list_update",
  default: new Date(),
});

export const projectUpdate = atom({
  key: "PROJECT/update",
  default: new Date(),
});

export const projectFilterState = atom({
  key: "PROJECT/filter",
  default: {},
});

export const asyncGetProjectList = selector({
  key: "PROJECT/list_get",
  get: async ({ get }) => {
    get(projectListUpdate);
    const param = get(projectFilterState);

    let projectList = [];
    try {
      projectList = (await getProjectList(param)).results;
    } catch (e) {
      console.log(e);
    }
    return [...projectList].map(({ usage, ...i }) => ({
      ...i,
      sentiment: sentimentCalc(usage),
    }));
  },
});

export const asyncGetProject = selector({
  key: "PROJECT/get",
  get: async ({ get }) => {
    get(projectUpdate);

    const pid = get(currentProject);

    if (isNaN(pid) || pid === 0) return;

    let projectInfo: projectType = {
      id: 0,
      name: "",
      category: "",
      created_at: null,
      usage: {
        words: { positive: 0, neutral: 0, negative: 0 },
      },
    };

    try {
      const data = { ...(await getProject(pid)) };
      projectInfo = {
        ...data,
        sentiment: sentimentCalc(data.usage),
      };
    } catch (e) {
      console.log(e.toString());
    }

    return projectInfo;
  },
});

export const categoryState = atom({
  key: "PROJECT/category_detail_state",
  default: [] as categoryType[],
});

export const asyncGetCategory = selector({
  key: "PROJECT/get_category",
  get: async () => {
    let returnVal: categoryType[] = [];
    try {
      returnVal = [...(await getCategory())];
    } catch (e) {
      console.log(e);
    }

    return returnVal;
  },
});

export const asyncGetCategoryDetail = selectorFamily({
  key: "PROJECT/get_category_detail",
  get:
    ({ category }: { category: string }) =>
    async () => {
      let returnVal: string[] = [];
      try {
        returnVal = await getCategoryDetail({ category });
      } catch (e) {
        console.log(e);
      }

      return returnVal;
    },
});

export const asyncGetCategoryRequestList = selector({
  key: "PROJECT/get_request_list",
  get: async () => {
    let returnVal;

    try {
      returnVal = await getCategoryRequestList();
    } catch (e) {
      console.log(e);
    }

    return returnVal;
  },
});
